export var fileExtensions = [{
  type: 'application/pdf',
  extension: 'pdf'
}, {
  type: 'text/csv',
  extension: 'csv'
}];
/**
 * Add file extension to fileExtension configurations
 */

export var addFileExtension = function addFileExtension(type, extension) {
  fileExtensions.push({
    type: type,
    extension: extension
  });
};